/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module carousel-transition/bulbcarouseltransition
 */

import { Plugin } from 'ckeditor5';
import BulbCarouselTransitionUi from './bulbcarouseltransitionui';

/**
 * Feature to handle transition with multiple option for Carousel.
 *
 * @extends Plugin
 */
export default class BulbCarouselTransition extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbCarouselTransitionUi] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbCarouselTransition' as const;
  }
}
